import { Link } from "react-router-dom";
import { Menu, X, Search as SearchIcon } from "lucide-react";
import { useEffect, useState } from "react";
import api from "@/lib/api";
import EmergencyBanner from "@/components/EmergencyBanner";
import WeatherStrip from "@/components/WeatherStrip";
import MandiStrip from "@/components/MandiStrip";
import FuelDeltaTicker from "@/components/FuelDeltaTicker";
import BrandLogo from "@/components/BrandLogo";

const NAV = [
  { name: "मुखपृष्ठ", slug: "" },
  { name: "राजनीति", slug: "rajniti" },
  { name: "राष्ट्रीय", slug: "rashtriya" },
  { name: "अंतरराष्ट्रीय", slug: "antarrashtriya" },
  { name: "व्यापार", slug: "vyapar" },
  { name: "खेल", slug: "khel" },
  { name: "मनोरंजन", slug: "manoranjan" },
  { name: "तकनीक", slug: "takniki" },
  { name: "स्थानीय", slug: "sthaniya" },
  { name: "वीडियो", slug: "__videos" },
  { name: "संपादकीय", slug: "__editor" },
  { name: "बाज़ार", slug: "__classifieds" },
  { name: "रोज़गार", slug: "__jobs" },
  { name: "LIVE", slug: "__live" },
  { name: "🗺️ छत्तीसगढ़", slug: "__cg" },
  { name: "🩸 रक्तदान", slug: "__blood" },
  { name: "🙋 योगदान", slug: "__contribute" },
  { name: "🎂 शुभकामना", slug: "__wishsubmit" },
  { name: "सहयोग करें", slug: "__support" },
  { name: "विज्ञापन दें", slug: "__postad" },
  { name: "प्रीमियम", slug: "__subscribe" },
  { name: "संपर्क", slug: "__contact" },
];

export default function PublicHeader() {
  const [date] = useState(new Date().toLocaleDateString("hi-IN", { weekday: "long", year: "numeric", month: "long", day: "numeric" }));
  const [breaking, setBreaking] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    api.get("/news", { params: { breaking: true, limit: 5 } }).then((r) => setBreaking(r.data)).catch(() => {});
  }, []);

  return (
    <header className="glass-header sticky top-0 z-40">
      <EmergencyBanner />
      <div className="bg-[#0F172A] text-white">
        <div className="max-w-7xl mx-auto px-4 py-1 md:py-1.5 flex items-center justify-between text-[10px] md:text-[11px] font-admin">
          <div className="flex items-center gap-1.5 md:gap-2 tracking-wide min-w-0" data-testid="editor-strip">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-amber-400 shrink-0 md:w-3.5 md:h-3.5"><path d="M5 16L3 6l5.5 4L12 4l3.5 6L21 6l-2 10H5zm0 2h14v2H5v-2z" fill="currentColor"/></svg>
            <span className="uppercase tracking-widest text-amber-300 font-black text-[9px] md:text-[11px] hidden sm:inline">Chief & Editor</span>
            <span className="text-slate-500 hidden sm:inline">·</span>
            <span className="font-black text-white text-[11px] md:text-[13px] tracking-wider truncate">JAKIR MOMIN</span>
            <span className="hidden md:inline text-amber-200/80 text-[10px] font-semibold">— प्रधान संपादक</span>
          </div>
          <div className="hidden md:block text-slate-400">📍 Sirsi Nawapara, Surajpur (CG) · +91 8463860303</div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-2 md:py-3">
        <div className="flex items-center justify-between gap-3 md:gap-4">
          <Link to="/" className="flex items-center gap-2 md:gap-3 min-w-0" data-testid="site-logo">
            <BrandLogo size={40} className="md:hidden"/>
            <BrandLogo size={56} className="hidden md:block"/>
            <div className="min-w-0">
              <div className="font-devnagri-heading text-base sm:text-xl md:text-2xl font-black text-[#0F172A] leading-none tracking-tight truncate">INDIAN-NEWS-21</div>
              <div className="text-[9px] md:text-[10px] uppercase tracking-widest text-[#EA580C] font-admin mt-0.5 md:mt-1 font-bold">भारत की आवाज़</div>
            </div>
          </Link>
          <div className="hidden lg:block text-sm text-slate-600 font-serif-hi">{date}</div>
          <div className="flex items-center gap-2 md:gap-3">
            <Link to="/search" className="md:hidden p-2 -mr-1 rounded-full hover:bg-slate-100 text-slate-700 active:bg-slate-200" data-testid="mob-search-btn" aria-label="खोजें">
              <SearchIcon className="w-5 h-5"/>
            </Link>
            <Link to="/admin/login" className="hidden md:inline text-xs font-admin uppercase tracking-wider text-slate-600 hover:text-[#1E3A8A]" data-testid="admin-link">व्यवस्थापक</Link>
            <button className="md:hidden p-2 rounded-full hover:bg-slate-100 active:bg-slate-200" data-testid="mobile-menu-btn" onClick={() => setMenuOpen(v => !v)} aria-label="मेनू">
              {menuOpen ? <X className="w-6 h-6 text-slate-700"/> : <Menu className="w-6 h-6 text-slate-700"/>}
            </button>
          </div>
        </div>
        <nav className="hidden md:flex items-center gap-6 mt-3 pt-3 border-t border-slate-100 overflow-x-auto">
          {NAV.map((n) => (
            <Link key={n.name} to={
              n.slug === "__contact" ? "/contact" :
              n.slug === "__videos" ? "/videos" :
              n.slug === "__editor" ? "/editor" :
              n.slug === "__support" ? "/support" :
              n.slug === "__postad" ? "/post-ad" :
              n.slug === "__classifieds" ? "/classifieds" :
              n.slug === "__jobs" ? "/jobs" :
              n.slug === "__live" ? "/live" :
              n.slug === "__cg" ? "/cg" :
              n.slug === "__blood" ? "/blood" :
              n.slug === "__contribute" ? "/contribute" :
              n.slug === "__wishsubmit" ? "/wishes-submit" :
              n.slug === "__subscribe" ? "/subscribe" :
              (n.slug ? `/category/${n.slug}` : "/")}
              className={`text-sm font-medium whitespace-nowrap ${
                n.slug === "__videos" ? "text-[#DC2626] font-bold" :
                n.slug === "__editor" ? "text-amber-600 font-bold" :
                n.slug === "__support" ? "text-emerald-700 font-bold" :
                n.slug === "__postad" ? "text-[#1E3A8A] font-bold" :
                n.slug === "__live" ? "text-red-600 font-bold animate-pulse" :
                n.slug === "__blood" ? "text-red-700 font-bold" :
                n.slug === "__contribute" ? "text-[#EA580C] font-bold" :
                n.slug === "__wishsubmit" ? "text-amber-700 font-bold" :
                n.slug === "__subscribe" ? "text-amber-700 font-bold" :
                "text-slate-700 hover:text-[#DC2626]"}`}
              data-testid={`nav-${n.slug || 'home'}`}>
              {n.name}
            </Link>
          ))}
          <Link to="/search" className="ml-2 p-2 rounded-full hover:bg-slate-100 text-slate-700" data-testid="header-search-btn" title="खोजें">
            <SearchIcon className="w-4 h-4"/>
          </Link>
        </nav>
        {menuOpen && (
          <nav className="md:hidden mt-3 pt-3 border-t border-slate-100 grid grid-cols-2 gap-x-4 gap-y-3" data-testid="mobile-menu">
            {NAV.map((n) => (
              <Link key={n.name} to={
                n.slug === "__contact" ? "/contact" :
                n.slug === "__videos" ? "/videos" :
                n.slug === "__editor" ? "/editor" :
                n.slug === "__support" ? "/support" :
                n.slug === "__postad" ? "/post-ad" :
                n.slug === "__classifieds" ? "/classifieds" :
                n.slug === "__jobs" ? "/jobs" :
                n.slug === "__live" ? "/live" :
                n.slug === "__cg" ? "/cg" :
                n.slug === "__blood" ? "/blood" :
                n.slug === "__contribute" ? "/contribute" :
                n.slug === "__wishsubmit" ? "/wishes-submit" :
                n.slug === "__subscribe" ? "/subscribe" :
                (n.slug ? `/category/${n.slug}` : "/")}
                className={`text-sm font-medium ${
                  n.slug === "__videos" ? "text-[#DC2626] font-bold" :
                  n.slug === "__editor" ? "text-amber-600 font-bold" :
                  n.slug === "__support" ? "text-emerald-700 font-bold" :
                  n.slug === "__postad" ? "text-[#1E3A8A] font-bold" :
                  n.slug === "__live" ? "text-red-600 font-bold" :
                  n.slug === "__blood" ? "text-red-700 font-bold" :
                  n.slug === "__contribute" ? "text-[#EA580C] font-bold" :
                  n.slug === "__wishsubmit" ? "text-amber-700 font-bold" :
                  n.slug === "__subscribe" ? "text-amber-700 font-bold" :
                  "text-slate-700 hover:text-[#DC2626]"}`}
                onClick={() => setMenuOpen(false)}
                data-testid={`mnav-${n.slug || 'home'}`}>
                {n.name}
              </Link>
            ))}
            <Link to="/admin/login" onClick={() => setMenuOpen(false)} className="text-sm font-medium text-slate-500 col-span-2 pt-2 border-t border-slate-100" data-testid="mnav-admin">व्यवस्थापक</Link>
          </nav>
        )}
      </div>

      <div className="hidden md:block">
        <WeatherStrip />
        <MandiStrip />
        <FuelDeltaTicker />
      </div>

      {breaking.length > 0 && (
        <div className="bg-[#DC2626] text-white overflow-hidden">
          <div className="max-w-7xl mx-auto px-3 md:px-4 py-1 md:py-1.5 flex items-center gap-2 md:gap-4">
            <span className="tag-breaking bg-white text-[#DC2626] shrink-0 text-[10px] md:text-xs">ब्रेकिंग</span>
            <div className="overflow-hidden flex-1">
              <div className="marquee-track text-xs md:text-sm">
                {[...breaking, ...breaking].map((b, i) => <span key={`${b.id}-${i}`} className="mr-10 md:mr-12">• {b.title}</span>)}
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
